import { BrowseActionTypes } from "../models/browseActions";
import { SET_PAGE } from "../types";

export default (page: number): BrowseActionTypes => ({
    type: SET_PAGE,
    payload: page,
});
